var _g, _path, _path2, _path3, _path4, _path5, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadOnAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420 120",
    enableBackground: "new 0 0 420 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#020202",
    d: "M396,120H24c-13.3,0-24-10.7-24-24V24C0,10.7,10.7,0,24,0h372c13.3,0,24,10.7,24,24v72 C420,109.3,409.3,120,396,120z"
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "60,59 88,59 88,34 60,37.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "58,59 58,37.8 36,40.7 36,59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "60,61 60,82.5 88,86 88,61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "58,61 36,61 36,79.3 58,82.2  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 114.3,
    y: 34.3,
    display: "inline",
    fill: "none",
    width: 274,
    height: 60.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 114.3329 52.08)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#FFFFFF",
    fontFamily: "'SegoeWP'",
    fontSize: 24
  }, "Download from"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33.6,
    fill: "#FFFFFF",
    fontFamily: "'SegoeWP'",
    fontSize: 28
  }, "Windows Phone Store")))), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M396,120H24c-13.3,0-24-10.7-24-24V24C0,10.7,10.7,0,24,0h372c13.3,0,24,10.7,24,24v72 C420,109.3,409.3,120,396,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.9326,
    y1: 66.2303,
    x2: 72.915,
    y2: 52.4576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCD08F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79673"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M74.3,69.1c6.6-3.6,11.6-6.3,12.1-6.6c1.4-0.7,2.8-2.6,0-4.2c-0.9-0.5-5.8-3.2-12.1-6.6l-8.6,8.7 L74.3,69.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.7287,
    y1: 64.1797,
    x2: 43.0089,
    y2: 92.8331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E74047"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F50A0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M65.7,60.4L38.1,88.3c0.6,0.1,1.4-0.1,2.2-0.6c1.8-1,21-11.5,34-18.6L65.7,60.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.8708,
    y1: 56.41,
    x2: 42.7271,
    y2: 28.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#47BEBC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M65.7,60.4l8.6-8.7c0,0-32.1-17.5-34-18.6c-0.7-0.4-1.5-0.5-2.3-0.4L65.7,60.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8539,
    y1: 88.2521,
    x2: 50.8539,
    y2: 32.7929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#84E9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#197491"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M65.7,60.4L38.1,32.8C36.9,33,36,34,36,36c0,3.2,0,46.2,0,48.9c0,1.9,0.7,3.2,2.1,3.3L65.7,60.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M298.5,87.6c-1.5,0-2.8-0.3-4-0.8c-1.2-0.5-2.2-1.4-3.1-2.5h-0.2c0.2,1.3,0.2,2.6,0.2,3.8v9.3H288V64.6 h2.8l0.5,3.1h0.2c0.9-1.2,1.9-2.1,3.1-2.7c1.2-0.6,2.5-0.8,4-0.8c3,0,5.3,1,6.9,3.1c1.6,2.1,2.4,4.9,2.4,8.6 c0,3.7-0.8,6.6-2.5,8.7C303.8,86.6,301.5,87.6,298.5,87.6z M298,67.1c-2.3,0-4,0.6-5,1.9c-1,1.3-1.6,3.3-1.6,6.1v0.8 c0,3.2,0.5,5.5,1.6,6.8c1.1,1.4,2.8,2.1,5.1,2.1c2,0,3.5-0.8,4.6-2.4c1.1-1.6,1.7-3.8,1.7-6.5c0-2.8-0.6-5-1.7-6.5 C301.6,67.8,300,67.1,298,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M315.9,87.2h-3.4V55.1h3.4V87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M335.6,87.2l-0.7-3.2h-0.2c-1.1,1.4-2.3,2.4-3.4,2.9c-1.1,0.5-2.5,0.8-4.2,0.8c-2.2,0-4-0.6-5.3-1.7 c-1.3-1.2-1.9-2.8-1.9-4.9c0-4.6,3.7-7,11-7.2l3.8-0.1v-1.4c0-1.8-0.4-3.1-1.1-3.9c-0.8-0.8-2-1.3-3.7-1.3c-1.9,0-4,0.6-6.4,1.7 l-1.1-2.6c1.1-0.6,2.3-1.1,3.7-1.4c1.3-0.3,2.7-0.5,4-0.5c2.7,0,4.7,0.6,6,1.8c1.3,1.2,2,3.1,2,5.8v15.4H335.6z M327.8,84.8 c2.1,0,3.8-0.6,5-1.8c1.2-1.2,1.8-2.8,1.8-4.9v-2l-3.4,0.1c-2.7,0.1-4.7,0.5-5.9,1.3c-1.2,0.7-1.8,1.9-1.8,3.5 c0,1.2,0.4,2.2,1.1,2.8C325.4,84.5,326.5,84.8,327.8,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M340.1,64.6h3.7l5,12.9c1.1,2.9,1.8,5.1,2,6.4h0.2c0.2-0.7,0.6-1.9,1.1-3.6c0.6-1.7,2.4-6.9,5.6-15.7h3.7 l-9.7,25.8c-1,2.5-2.1,4.4-3.4,5.4c-1.3,1.1-2.9,1.6-4.7,1.6c-1,0-2.1-0.1-3.1-0.4v-2.7c0.8,0.2,1.6,0.2,2.5,0.2c2.4,0,4-1.3,5-4 l1.3-3.2L340.1,64.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M235,66.7c1.1,0.9,3.4,2.8,3.4,6.4c0,3.5-2,5.2-4,6.7c-0.6,0.6-1.3,1.3-1.3,2.3c0,1,0.7,1.6,1.2,2 l1.7,1.3c2.1,1.8,4,3.4,4,6.6c0,4.4-4.3,8.9-12.4,8.9c-6.9,0-10.2-3.3-10.2-6.8c0-1.7,0.8-4.1,3.6-5.8c2.9-1.8,6.9-2,9-2.2 c-0.7-0.9-1.4-1.8-1.4-3.2c0-0.8,0.2-1.3,0.5-1.8c-0.5,0-1,0.1-1.5,0.1c-5,0-7.9-3.7-7.9-7.4c0-2.2,1-4.6,3-6.3 c2.7-2.2,5.9-2.6,8.5-2.6h9.8l-3,1.7H235z M231.7,87.7c-0.4,0-0.6,0-1.1,0c-0.4,0-3,0.1-5,0.8c-1,0.4-4.1,1.5-4.1,4.9 c0,3.4,3.3,5.8,8.3,5.8c4.5,0,7-2.2,7-5.1C236.8,91.5,235.3,90.3,231.7,87.7z M233,78.7c1.1-1.1,1.2-2.6,1.2-3.5 c0-3.4-2-8.7-6-8.7c-1.2,0-2.6,0.6-3.3,1.6c-0.8,1-1,2.3-1,3.5c0,3.2,1.8,8.4,5.9,8.4C231,80,232.3,79.5,233,78.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M205.2,86.9c-7.5,0-11.5-5.9-11.5-11.2c0-6.2,5.1-11.5,12.2-11.5c6.9,0,11.3,5.4,11.3,11.2 C217.2,81,212.9,86.9,205.2,86.9z M211.1,83.1c1.1-1.5,1.4-3.4,1.4-5.2c0-4.2-2-12.1-7.8-12.1c-1.6,0-3.1,0.6-4.3,1.6 c-1.8,1.7-2.2,3.7-2.2,5.8c0,4.7,2.3,12.4,8,12.4C208.2,85.5,210,84.6,211.1,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M179.6,86.9c-7.5,0-11.5-5.9-11.5-11.2c0-6.2,5.1-11.5,12.2-11.5c6.9,0,11.3,5.4,11.3,11.2 C191.6,81,187.3,86.9,179.6,86.9z M185.5,83.1c1.1-1.5,1.4-3.4,1.4-5.2c0-4.2-2-12.1-7.8-12.1c-1.6,0-3.1,0.6-4.3,1.6 c-1.8,1.7-2.2,3.7-2.2,5.8c0,4.7,2.3,12.4,8,12.4C182.5,85.5,184.4,84.6,185.5,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M164.5,86.2l-6.8,1.6c-2.8,0.4-5.2,0.8-7.8,0.8c-13.1,0-18.1-9.6-18.1-17.2c0-9.2,7.1-17.8,19.2-17.8 c2.6,0,5,0.4,7.3,1c3.6,1,5.2,2.2,6.3,2.9l-3.9,3.8l-1.7,0.4l1.2-1.9c-1.6-1.6-4.6-4.5-10.2-4.5c-7.5,0-13.2,5.7-13.2,14 c0,8.9,6.5,17.3,16.8,17.3c3,0,4.6-0.6,6-1.2v-7.6l-7.2,0.4l3.8-2h10.1l-1.2,1.2c-0.3,0.3-0.4,0.4-0.5,0.8c0,0.4-0.1,1.8-0.1,2.3 V86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M250,84.8c-1.6-0.1-1.9-0.4-1.9-2.3V82V55.7c0-0.1,0-0.2,0-0.3c0.2-1.7,0.7-1.9,2.1-2.8h-6.8l-3.6,1.7 h3.6v0l0,0V82v1.6c0,0.9-0.2,1.1-1.3,2.5h8.4l1.8-1C251.7,85,250.9,84.9,250,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M269.4,85.3c-0.5,0.3-1,0.6-1.6,0.8c-1.6,0.7-3.2,0.9-4.6,0.9c-1.5,0-3.9-0.1-6.3-1.8 c-3.3-2.4-4.8-6.4-4.8-10c0-7.3,5.9-10.9,10.8-10.9c1.7,0,3.4,0.4,4.9,1.3c2.4,1.6,3,3.6,3.3,4.7L260,74.8l-3.6,0.3 c1.2,6,5.2,9.5,9.7,9.5c2.4,0,4.2-0.8,5.8-1.6L269.4,85.3z M265,71.2c0.9-0.3,1.4-0.6,1.4-1.3c0-1.9-2.1-4.1-4.7-4.1 c-1.9,0-5.4,1.5-5.4,6.6c0,0.8,0.1,1.7,0.1,2.5L265,71.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M273.9,64.6v3.1h-0.4v-3.1h-1v-0.3h2.4v0.3H273.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M278.2,67.8v-3.1h0l-1,3.1h-0.3l-1-3.1h0v3.1h-0.3v-3.4h0.6l0.9,2.8h0l0.9-2.8h0.6v3.4H278.2z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146,39.7c-0.2,0.2-0.4,0.4-0.8,0.7c-0.3,0.2-0.7,0.5-1.2,0.7c-0.5,0.2-1.1,0.4-1.7,0.5s-1.4,0.2-2.3,0.2 c-1,0-1.9-0.2-2.8-0.5s-1.5-0.8-2.1-1.4c-0.6-0.6-1-1.4-1.4-2.3c-0.3-0.9-0.5-2-0.5-3.1v-0.9c0-1.2,0.2-2.2,0.5-3.1 c0.3-0.9,0.7-1.7,1.3-2.3s1.3-1.1,2.1-1.4c0.8-0.3,1.7-0.5,2.7-0.5c1,0,1.9,0.1,2.6,0.4c0.7,0.2,1.4,0.6,1.8,1 c0.5,0.4,0.9,1,1.2,1.6c0.3,0.6,0.5,1.3,0.5,2h-3.1c-0.1-0.4-0.2-0.7-0.3-1s-0.3-0.6-0.6-0.8c-0.2-0.2-0.5-0.4-0.9-0.5 c-0.3-0.1-0.8-0.2-1.2-0.2c-1.1,0-1.9,0.4-2.5,1.2s-0.9,2-0.9,3.6v0.9c0,1.6,0.3,2.8,0.9,3.6c0.6,0.8,1.5,1.2,2.7,1.2 c0.4,0,0.7,0,1-0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.2s0.2-0.2,0.3-0.3v-2.6h-2.9v-2.3h6.1V39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M158,35h-6.2v4.1h7.2v2.5h-10.4V26.4H159v2.5h-7.2v3.6h6.2V35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M172.8,28.9h-4.8v12.7h-3.2V28.9h-4.7v-2.5h12.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M182.9,41.6h-3.2V26.4h3.2V41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M197.3,28.9h-4.8v12.7h-3.2V28.9h-4.7v-2.5h12.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M216.7,34.3c0,1.2-0.2,2.2-0.5,3.1s-0.8,1.7-1.4,2.3c-0.6,0.6-1.3,1.1-2.1,1.5c-0.8,0.3-1.7,0.5-2.7,0.5 c-1,0-1.9-0.2-2.7-0.5c-0.8-0.3-1.5-0.8-2.1-1.5s-1-1.4-1.4-2.3c-0.3-0.9-0.5-2-0.5-3.1v-0.7c0-1.2,0.2-2.2,0.5-3.1 c0.3-0.9,0.8-1.7,1.4-2.4c0.6-0.6,1.3-1.1,2.1-1.5c0.8-0.3,1.7-0.5,2.7-0.5c1,0,1.9,0.2,2.7,0.5c0.8,0.3,1.5,0.8,2.1,1.5 c0.6,0.6,1,1.4,1.4,2.4s0.5,2,0.5,3.1V34.3z M213.4,33.6c0-1.6-0.3-2.8-0.9-3.6c-0.6-0.8-1.4-1.2-2.5-1.2c-1.1,0-1.9,0.4-2.5,1.2 c-0.6,0.8-0.9,2-0.9,3.6v0.7c0,0.8,0.1,1.5,0.2,2.1c0.2,0.6,0.4,1.1,0.7,1.5c0.3,0.4,0.6,0.7,1.1,0.9c0.4,0.2,0.9,0.3,1.4,0.3 c1.1,0,1.9-0.4,2.5-1.3c0.6-0.8,0.9-2.1,0.9-3.6V33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M231.7,41.6h-3.2l-6.2-10v10H219V26.4h3.2l6.3,10v-10h3.2V41.6z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M396,120H24c-13.3,0-24-10.7-24-24V24C0,10.7,10.7,0,24,0h372c13.3,0,24,10.7,24,24v72 C420,109.3,409.3,120,396,120z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.8,58c-0.1-8.1,6.6-12,6.9-12.2c-3.8-5.5-9.7-6.3-11.7-6.3c-4.9-0.5-9.7,2.9-12.2,2.9 c-2.6,0-6.4-2.9-10.6-2.8c-5.4,0.1-10.4,3.2-13.1,8c-5.7,9.8-1.4,24.3,4,32.2c2.7,3.9,5.9,8.2,10.1,8.1c4.1-0.2,5.6-2.6,10.5-2.6 c4.9,0,6.3,2.6,10.5,2.5c4.4-0.1,7.1-3.9,9.7-7.8c3.1-4.5,4.4-8.9,4.5-9.1C88.3,70.9,79.9,67.7,79.8,58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.8,34.3c2.2-2.7,3.7-6.5,3.3-10.2c-3.2,0.1-7.1,2.2-9.4,4.9c-2,2.4-3.8,6.2-3.4,9.9 C65.9,39,69.5,37,71.8,34.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M172.3,89.2h-5.7l-3.1-9.8h-10.8l-3,9.8h-5.5L155,56h6.6L172.3,89.2z M162.6,75.3l-2.8-8.7 c-0.3-0.9-0.9-3-1.7-6.3H158c-0.3,1.4-0.9,3.5-1.6,6.3l-2.8,8.7H162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M199.8,76.9c0,4.1-1.1,7.3-3.3,9.7c-2,2.1-4.4,3.2-7.3,3.2c-3.2,0-5.4-1.1-6.8-3.4h-0.1v12.6H177V73.1 c0-2.6-0.1-5.2-0.2-7.9h4.7l0.3,3.8h0.1c1.8-2.9,4.5-4.3,8.1-4.3c2.8,0,5.2,1.1,7.1,3.3C198.9,70.3,199.8,73.3,199.8,76.9z  M194.4,77.1c0-2.3-0.5-4.3-1.6-5.8c-1.2-1.6-2.7-2.4-4.6-2.4c-1.3,0-2.5,0.4-3.6,1.3c-1.1,0.9-1.8,2-2.1,3.4 c-0.2,0.7-0.2,1.2-0.2,1.6v4c0,1.7,0.5,3.2,1.6,4.4c1.1,1.2,2.5,1.8,4.2,1.8c2,0,3.6-0.8,4.7-2.3 C193.8,81.7,194.4,79.6,194.4,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M227.4,76.9c0,4.1-1.1,7.3-3.3,9.7c-2,2.1-4.4,3.2-7.3,3.2c-3.2,0-5.4-1.1-6.8-3.4h-0.1v12.6h-5.3V73.1 c0-2.6-0.1-5.2-0.2-7.9h4.7l0.3,3.8h0.1c1.8-2.9,4.5-4.3,8.1-4.3c2.8,0,5.2,1.1,7.1,3.3C226.4,70.3,227.4,73.3,227.4,76.9z  M221.9,77.1c0-2.3-0.5-4.3-1.6-5.8c-1.2-1.6-2.7-2.4-4.6-2.4c-1.3,0-2.5,0.4-3.6,1.3c-1.1,0.9-1.8,2-2.1,3.4 c-0.2,0.7-0.2,1.2-0.2,1.6v4c0,1.7,0.5,3.2,1.6,4.4c1.1,1.2,2.5,1.8,4.2,1.8c2,0,3.6-0.8,4.7-2.3 C221.4,81.7,221.9,79.6,221.9,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.2,79.9c0,2.8-1,5.1-2.9,6.9c-2.2,1.9-5.2,2.9-9,2.9c-3.6,0-6.4-0.7-8.6-2.1l1.2-4.4 c2.3,1.4,4.9,2.1,7.7,2.1c2,0,3.6-0.5,4.7-1.4c1.1-0.9,1.7-2.1,1.7-3.6c0-1.3-0.5-2.5-1.4-3.4c-0.9-0.9-2.4-1.8-4.6-2.6 c-5.8-2.2-8.7-5.3-8.7-9.5c0-2.7,1-5,3.1-6.7c2-1.7,4.7-2.6,8.1-2.6c3,0,5.5,0.5,7.5,1.6l-1.3,4.3c-1.9-1-4-1.5-6.4-1.5 c-1.9,0-3.3,0.5-4.4,1.4c-0.9,0.8-1.3,1.8-1.3,3c0,1.3,0.5,2.4,1.5,3.3c0.9,0.8,2.5,1.6,4.8,2.6c2.9,1.2,5,2.5,6.3,4 C257.5,75.6,258.2,77.6,258.2,79.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.7,69.2h-5.9v11.6c0,3,1,4.4,3.1,4.4c1,0,1.7-0.1,2.4-0.2l0.1,4c-1,0.4-2.4,0.6-4.1,0.6 c-2.1,0-3.7-0.6-4.9-1.9c-1.2-1.3-1.8-3.4-1.8-6.5V69.2h-3.5v-4h3.5v-4.4l5.2-1.6v6h5.9C275.7,65.2,275.7,69.2,275.7,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M302.2,77c0,3.7-1.1,6.7-3.2,9.1c-2.2,2.4-5.1,3.6-8.8,3.6c-3.5,0-6.3-1.2-8.4-3.5s-3.1-5.3-3.1-8.8 c0-3.7,1.1-6.7,3.2-9.1c2.1-2.4,5-3.5,8.7-3.5c3.5,0,6.3,1.2,8.5,3.5C301.2,70.5,302.2,73.4,302.2,77z M296.7,77.2 c0-2.2-0.5-4.1-1.4-5.7c-1.1-1.9-2.7-2.9-4.8-2.9c-2.1,0-3.8,1-4.9,2.9c-1,1.6-1.4,3.5-1.4,5.8c0,2.2,0.5,4.1,1.4,5.7 c1.2,1.9,2.8,2.9,4.8,2.9c2,0,3.6-1,4.8-2.9C296.2,81.3,296.7,79.4,296.7,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.5,69.9c-0.5-0.1-1.1-0.1-1.7-0.1c-1.9,0-3.3,0.7-4.3,2.1c-0.9,1.2-1.3,2.8-1.3,4.7v12.6h-5.3l0-16.4 c0-2.8-0.1-5.3-0.2-7.5h4.6l0.2,4.6h0.1c0.6-1.6,1.4-2.8,2.7-3.8c1.2-0.9,2.5-1.3,3.8-1.3c0.5,0,0.9,0,1.3,0.1 C319.5,64.8,319.5,69.9,319.5,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M343.3,76.1c0,1-0.1,1.8-0.2,2.4h-16c0.1,2.4,0.8,4.2,2.3,5.4c1.3,1.1,3.1,1.7,5.2,1.7 c2.4,0,4.5-0.4,6.5-1.1l0.8,3.7c-2.3,1-4.9,1.5-8,1.5c-3.7,0-6.6-1.1-8.7-3.3c-2.1-2.2-3.2-5.1-3.2-8.8c0-3.6,1-6.6,3-9 c2.1-2.6,4.9-3.8,8.4-3.8c3.5,0,6.1,1.3,7.8,3.8C342.6,70.6,343.3,73.1,343.3,76.1z M338.2,74.7c0-1.6-0.3-2.9-1-4.1 c-0.9-1.5-2.3-2.2-4.2-2.2c-1.7,0-3.2,0.7-4.2,2.2c-0.9,1.2-1.4,2.5-1.6,4.1L338.2,74.7L338.2,74.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.9,35.5c0,2.9-0.9,5.1-2.6,6.6c-1.6,1.4-3.9,2.1-6.9,2.1c-1.5,0-2.8-0.1-3.8-0.2V28 c1.4-0.2,2.9-0.3,4.5-0.3c2.9,0,5,0.6,6.5,1.9C160.1,30.9,160.9,32.9,160.9,35.5z M158.1,35.6c0-1.9-0.5-3.4-1.5-4.4 c-1-1-2.5-1.5-4.4-1.5c-0.8,0-1.5,0.1-2.1,0.2v12.2c0.3,0,0.9,0.1,1.8,0.1c2,0,3.5-0.6,4.6-1.7S158.1,37.7,158.1,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M175.5,38.1c0,1.8-0.5,3.3-1.5,4.5c-1.1,1.2-2.5,1.8-4.3,1.8c-1.7,0-3.1-0.6-4.1-1.7 c-1-1.1-1.5-2.6-1.5-4.3c0-1.8,0.5-3.3,1.6-4.5c1.1-1.2,2.5-1.7,4.3-1.7c1.7,0,3.1,0.6,4.2,1.7C175,34.9,175.5,36.3,175.5,38.1z  M172.8,38.2c0-1.1-0.2-2-0.7-2.8c-0.5-0.9-1.3-1.4-2.3-1.4c-1.1,0-1.8,0.5-2.4,1.4c-0.5,0.8-0.7,1.7-0.7,2.8 c0,1.1,0.2,2,0.7,2.8c0.6,0.9,1.4,1.4,2.4,1.4c1,0,1.8-0.5,2.3-1.4C172.5,40.2,172.8,39.3,172.8,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M195.1,32.3l-3.7,11.8H189l-1.5-5.1c-0.4-1.3-0.7-2.5-0.9-3.8h0c-0.2,1.3-0.5,2.6-0.9,3.8l-1.6,5.1h-2.4 l-3.5-11.8h2.7l1.3,5.6c0.3,1.3,0.6,2.6,0.8,3.8h0c0.2-1,0.5-2.2,1-3.8l1.7-5.6h2.1l1.6,5.5c0.4,1.3,0.7,2.6,0.9,3.9h0.1 c0.2-1.2,0.4-2.5,0.8-3.9l1.4-5.5L195.1,32.3L195.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M208.7,44.1H206v-6.7c0-2.1-0.8-3.1-2.4-3.1c-0.8,0-1.4,0.3-1.9,0.9c-0.5,0.6-0.7,1.2-0.7,2v7h-2.6v-8.4 c0-1,0-2.2-0.1-3.4h2.3l0.1,1.8h0.1c0.3-0.6,0.8-1,1.4-1.4c0.7-0.4,1.5-0.7,2.4-0.7c1.1,0,2,0.4,2.7,1.1 c0.9,0.9,1.4,2.2,1.4,3.9V44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M215.9,44.1h-2.6V26.9h2.6V44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M231.3,38.1c0,1.8-0.5,3.3-1.5,4.5c-1.1,1.2-2.5,1.8-4.3,1.8c-1.7,0-3.1-0.6-4.1-1.7 c-1-1.1-1.5-2.6-1.5-4.3c0-1.8,0.5-3.3,1.6-4.5c1.1-1.2,2.5-1.7,4.3-1.7c1.7,0,3.1,0.6,4.2,1.7 C230.8,34.9,231.3,36.3,231.3,38.1z M228.5,38.2c0-1.1-0.2-2-0.7-2.8c-0.5-0.9-1.3-1.4-2.3-1.4c-1.1,0-1.9,0.5-2.4,1.4 c-0.5,0.8-0.7,1.7-0.7,2.8c0,1.1,0.2,2,0.7,2.8c0.6,0.9,1.4,1.4,2.4,1.4c1,0,1.8-0.5,2.3-1.4C228.3,40.2,228.5,39.3,228.5,38.2z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M243.9,44.1h-2.3l-0.2-1.4h-0.1c-0.8,1.1-1.9,1.6-3.4,1.6c-1.1,0-2-0.4-2.7-1.1 c-0.6-0.6-0.9-1.4-0.9-2.4c0-1.4,0.6-2.5,1.8-3.3c1.2-0.8,2.9-1.1,5.1-1.1v-0.2c0-1.5-0.8-2.3-2.4-2.3c-1.2,0-2.2,0.3-3.1,0.9 l-0.5-1.7c1.1-0.7,2.4-1,4-1c3.1,0,4.6,1.6,4.6,4.9v4.3C243.7,42.4,243.8,43.4,243.9,44.1z M241.2,40v-1.8 c-2.9,0-4.3,0.7-4.3,2.4c0,0.6,0.2,1.1,0.5,1.4c0.3,0.3,0.8,0.5,1.3,0.5c0.6,0,1.1-0.2,1.6-0.5c0.5-0.4,0.8-0.8,0.9-1.4 C241.2,40.4,241.2,40.2,241.2,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.8,44.1h-2.3l-0.1-1.9h-0.1c-0.7,1.4-2,2.2-3.8,2.2c-1.4,0-2.6-0.6-3.5-1.7s-1.4-2.6-1.4-4.3 c0-1.9,0.5-3.4,1.5-4.6c1-1.1,2.2-1.6,3.6-1.6c1.6,0,2.7,0.5,3.3,1.6h0v-6.8h2.6v14C258.7,42,258.7,43.1,258.8,44.1z  M256.1,39.1v-2c0-0.3,0-0.6-0.1-0.8c-0.1-0.6-0.5-1.2-0.9-1.6c-0.5-0.4-1.1-0.6-1.7-0.6c-1,0-1.7,0.4-2.3,1.2 c-0.6,0.8-0.8,1.8-0.8,3c0,1.2,0.3,2.1,0.8,2.8c0.6,0.8,1.3,1.2,2.3,1.2c0.9,0,1.5-0.3,2.1-1C255.8,40.7,256.1,40,256.1,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M281.1,38.1c0,1.8-0.5,3.3-1.5,4.5c-1.1,1.2-2.5,1.8-4.3,1.8c-1.7,0-3.1-0.6-4.1-1.7 c-1-1.1-1.5-2.6-1.5-4.3c0-1.8,0.5-3.3,1.6-4.5c1.1-1.2,2.5-1.7,4.3-1.7c1.7,0,3.1,0.6,4.2,1.7 C280.6,34.9,281.1,36.3,281.1,38.1z M278.4,38.2c0-1.1-0.2-2-0.7-2.8c-0.6-0.9-1.3-1.4-2.3-1.4c-1,0-1.8,0.5-2.4,1.4 c-0.5,0.8-0.7,1.7-0.7,2.8c0,1.1,0.2,2,0.7,2.8c0.6,0.9,1.4,1.4,2.4,1.4c1,0,1.8-0.5,2.3-1.4C278.2,40.2,278.4,39.3,278.4,38.2z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M295.2,44.1h-2.6v-6.7c0-2.1-0.8-3.1-2.4-3.1c-0.8,0-1.4,0.3-1.9,0.9c-0.5,0.6-0.7,1.2-0.7,2v7H285v-8.4 c0-1,0-2.2-0.1-3.4h2.3l0.1,1.8h0.1c0.3-0.6,0.8-1,1.4-1.4c0.7-0.4,1.5-0.7,2.4-0.7c1.1,0,2,0.4,2.7,1.1 c0.9,0.9,1.4,2.2,1.4,3.9V44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312.8,34.3h-2.9V40c0,1.5,0.5,2.2,1.5,2.2c0.5,0,0.9,0,1.2-0.1l0.1,2c-0.5,0.2-1.2,0.3-2,0.3 c-1,0-1.8-0.3-2.4-0.9c-0.6-0.6-0.9-1.7-0.9-3.2v-5.9h-1.7v-2h1.7v-2.2l2.6-0.8v2.9h2.9L312.8,34.3L312.8,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M326.6,44.1H324v-6.7c0-2.1-0.8-3.2-2.4-3.2c-1.2,0-2,0.6-2.5,1.8c-0.1,0.3-0.1,0.6-0.1,0.9v7.1h-2.6 V26.9h2.6V34h0c0.8-1.3,2-1.9,3.5-1.9c1.1,0,2,0.4,2.7,1.1c0.9,0.9,1.3,2.2,1.3,3.9C326.6,37.1,326.6,44.1,326.6,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M340.9,37.6c0,0.5,0,0.9-0.1,1.2H333c0,1.2,0.4,2,1.1,2.7c0.7,0.5,1.5,0.8,2.6,0.8 c1.2,0,2.2-0.2,3.2-0.6l0.4,1.8c-1.1,0.5-2.4,0.7-3.9,0.7c-1.8,0-3.3-0.5-4.3-1.6c-1-1.1-1.6-2.5-1.6-4.3c0-1.8,0.5-3.3,1.5-4.4 c1-1.3,2.4-1.9,4.1-1.9c1.7,0,3,0.6,3.8,1.9C340.6,34.9,340.9,36.2,340.9,37.6z M338.4,37c0-0.8-0.2-1.4-0.5-2 c-0.5-0.7-1.1-1.1-2.1-1.1c-0.9,0-1.5,0.4-2.1,1.1c-0.4,0.6-0.7,1.2-0.8,2C333,37,338.4,37,338.4,37z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOnAppStore);
export default __webpack_public_path__ + "static/media/download-on-app-store.13ea450e5714a1e6930052c94695c02a.svg";
export { ForwardRef as ReactComponent };